import logo from './logo.svg';
import './App.css';
import Header from './components/header/Header';
import About from './components/about/About';
import Team from './components/team/Team';
import Footer from './components/footer/Footer';

function App() {
  return (
    <>
      <Header />
      <About />
      <Team />
      <Footer />
    </>
  );
}

export default App;
